import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw { message: 'Bill fetch service is currently unavailable (500).', code: 'SERVER_ERROR' }
  }
  if (isStatusOK(data) && data?.data?.responseStatus?.code === '000') {
    return data.data.responseObject
  } else {
    const errorBody = data?.data || data || { message: 'Unable to fetch bill details' }
    throw getNetworkResponseError(errorBody)
    // throw getNetworkResponseError(data?.data)
  }
}
export const billFetchAPI = (tokens: any, requestBody: any, jfsUserId: string) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || jfsUserId || ''
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  // config.headers['x-channel-user-id'] = RootStore.agent.agentInfo.agentUserLoginId || '1123766817865366323';
  config.headers['x-channel-user-id'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-intercept-gateway'] = 'SERVICE/JPB'

  const request: Request<{}> = {
    apiPath: APIEndPoints.billFetchAPI,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to respponse parse')
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
